import React from 'react'
import {Link} from 'react-router-dom'

function StartGame({gameState}) {    
    function route() {
        switch(gameState) {
            case 'newGame':
                return '/location/office/story'
    
            case 'machineGame':
                return '/location/machine/story'
    
            default:
                return '/map'   
        }
    }
    
    return (
        <>
            <h2>Ready to {gameState === 'newGame' ? 'begin' : 'jump back in'}?</h2>
            <Link to={route()}>
                <button className="landing_btn">Let's Go!</button>
            </Link>
        </>
    )
}

export default StartGame